var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudSolid = function SvgCloudSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.952 18a4.74 4.74 0 0 1-3.293-1.319A4.424 4.424 0 0 1 2.295 13.5c0-1.193.49-2.338 1.364-3.182A4.74 4.74 0 0 1 6.952 9c.292-1.313 1.145-2.466 2.372-3.207a5.874 5.874 0 0 1 2.005-.749 6.1 6.1 0 0 1 2.167.006c.715.132 1.394.39 2 .76.605.37 1.124.845 1.528 1.397.403.553.683 1.172.823 1.823.14.65.138 1.32-.007 1.97h.99c.92 0 1.8.369 2.45 1.025a3.519 3.519 0 0 1 1.015 2.475c0 .928-.365 1.819-1.015 2.475A3.447 3.447 0 0 1 18.83 18H6.952Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCloudSolid;